import { render } from "./EmployeeGatepass.vue?vue&type=template&id=4f7a1bf1&scoped=true"
import script from "./EmployeeGatepass.vue?vue&type=script&lang=js"
export * from "./EmployeeGatepass.vue?vue&type=script&lang=js"

import "./EmployeeGatepass.vue?vue&type=style&index=0&id=4f7a1bf1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7a1bf1"]])

export default __exports__